export default __webpack_public_path__ + "19aef057a59a97ac8fadebd58eb12f70.png";